module.exports = __webpack_public_path__ + "static/media/FesteaPOS.038e3591.webp";